import {PrescriptionsItemType} from 'domain/usecases/private/my-hospitalization/get-prescriptions-list';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {useDebounceSearch} from 'presentation/hooks/useDebounceSearch';
import {useGetPaginatedItemsReactQuery} from 'presentation/pages/private/hooks/useGetPaginatedItemsReactQuery';
import {getPrescriptionsList} from '../services/getPrescriptionsList';

const SIZE = 3;

export const usePrescriptions = () => {
	const {searchValueState, debouncedQueryFunc, clearSearchParams, abortDebounce} =
		useDebounceSearch({});

	const {
		items,
		loadingItemsList,
		itemsListIsEmpty,
		itemsListHasError,
		totalItems,
		loadMore,
		resetState,
		refresh,
		isLoading,
	} = useGetPaginatedItemsReactQuery<PrescriptionsItemType>({
		queryKey: [QUERY_KEYS.HOSPITALIZATION_PRESCRIPTIONS_LIST, searchValueState],
		queryFn: ({page}) =>
			getPrescriptionsList({
				'medication-name': searchValueState.toUpperCase(),
				page,
				size: SIZE,
			}),
	});

	return {
		items,
		loadingItemsList,
		isLoading,
		itemsListIsEmpty,
		itemsListHasError,
		totalItems,
		loadMore,
		resetState,
		refresh,
		searchValueState,
		debouncedQueryFunc,
		clearSearchParams,
		abortDebounce,
	};
};
